module.exports = __webpack_public_path__ + "static/media/art-active.d26eaecd.svg";